<template>
  <b-badge :variant="statusColors[device.device_status_text]">
    {{ device.device_status_text }}
  </b-badge>
</template>

<script>
export default {
	props: {
		device: {
			required: true
		}
	},
	computed: {
		statusColors () {
			return {
				Unknown: 'secondary',
				Syncing: 'info',
				Online: 'success',
				Unassigned: 'info',
				Offline: 'danger'
			};
		}
	}
};
</script>

<style scoped>

</style>
